<template lang="pug">
.v-acc.acc(v-if="data" :id="data?.id")
	.acc__items(v-if="data.length")
		.acc__item(v-for="(item, i) in data" :key="item.id || i" :class="{'open': active && item.id === active.id}")
			.acc__item-head(@click="toggleItem(item, $event)")
				img.acc__item-icon(v-if="item.icon" :src="item.icon")
				.acc__item-title(v-html="item.title")
				.acc__item-state
					v-svg-icon.acc__item-state-icon(icon="dropdown-small")
			.acc__item-body-wrap
				.acc__item-body
					.text-guide(v-html="item.text")
</template>

<script>

import sourceMixin from '../components/mixins/v-mixin-source.vue';

export default {
	mixins: [
		sourceMixin
	],

	props: {
		items: {
			type: Array,
			default: null
		}
	},

	data() {
		return {
			data: null,
			active: null
		};
	},

	watch: {
		items(state) {
			this.data = state;
			this.$nextTick(() => {
				this.setHeights();
			});
		}
	},

	mounted() {
		if (this.items) {
			this.data = this.items;
		}
	},

	created() {
		this.$nextTick(() => {
			this.setHeights();
		});
	},

	methods: {
		getNext(el, selector) {
			const nextEl = el.nextElementSibling;
			if (!selector || (nextEl && nextEl.matches(selector))) {
				return nextEl;
			}
			return null;
		},

		setHeight(el, val) {
			if (typeof val === 'function') val = val();
			if (typeof val === 'string') el.style.height = val;
			else el.style.height = val + 'px';
		},

		setHeights() {
			let $itemBodies = this.$el.querySelectorAll('.acc__item-body');
			if ($itemBodies && $itemBodies.length) {
				$itemBodies.forEach($bodyWrap => {
					$bodyWrap.setAttribute('data-height', $bodyWrap.getBoundingClientRect().height);
				});
			}
		},

		toggleItem(item, e) {
			let $currentTarget = e.currentTarget;
			let $itemBodyWrap = this.getNext($currentTarget);
			let height = +$itemBodyWrap.querySelector('.acc__item-body').getAttribute('data-height');
			let $closestControlBodyWrap = $currentTarget.closest('.acc-tabs__control-body-wrap');
			if ($closestControlBodyWrap) {
				this.setHeight($closestControlBodyWrap, 'auto');
			}
			if ($itemBodyWrap.classList.contains('open')) {
				$itemBodyWrap.classList.remove('open');
				this.setHeight($itemBodyWrap, 0);
				this.active = null;
			} else {
				$itemBodyWrap.classList.add('open');
				this.setHeight($itemBodyWrap, height);
				this.active = item;
			}
		},

		dataSet(data) {
			this.data = data;
		}
	}
};
</script>
